import type { PropsWithChildren } from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

type SaveBackdropProps = PropsWithChildren<{
  saving: boolean;
}>;
const SaveBackdrop = ({ saving }: SaveBackdropProps) => {
  return (
    <Backdrop
      open={saving}
      sx={{
        zIndex: "modal",
        color: "#fff",
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
export default SaveBackdrop;
